import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import { TGeneralAttachmentsStore, TGeneralAttachmentsListResponsePayload } from './types';

export const getGeneralAttachmentsState = (state: TStoreState): TGeneralAttachmentsStore =>
	state.generalAttachments;

export const getGeneralAttachments = createSelector(
	getGeneralAttachmentsState,
	(state: TGeneralAttachmentsStore): TGeneralAttachmentsListResponsePayload =>
		state.generalAttachments,
);

export const getGeneralAttachmentsLoading = createSelector(
	getGeneralAttachmentsState,
	(state: TGeneralAttachmentsStore): boolean => state.generalAttachmentsLoading,
);

export const getGeneralAttachmentCreateLoading = createSelector(
	getGeneralAttachmentsState,
	(state: TGeneralAttachmentsStore): boolean => state.createLoading,
);

export const getGeneralAttachmentUpdateLoading = createSelector(
	getGeneralAttachmentsState,
	(state: TGeneralAttachmentsStore): boolean => state.updateLoading,
);

export const getGeneralAttachmentDownloadLoading = createSelector(
	getGeneralAttachmentsState,
	(state: TGeneralAttachmentsStore): boolean => state.downloadLoading,
);

export const getGeneralAttachmentDeleteLoading = createSelector(
	getGeneralAttachmentsState,
	(state: TGeneralAttachmentsStore): boolean => state.deleteLoading,
);

export const getGeneralAttachmentAddVersionLoading = createSelector(
	getGeneralAttachmentsState,
	(state: TGeneralAttachmentsStore): boolean => state.addVersionLoading,
);
